import { useEffect } from "react";
import { memo, useState } from "react";
import './RoomItem.scss';

function RoomItem({data, onClick, type}) {
    if (!data) return <></>;

    const handleClick = () => {
        if (onClick)
            onClick(data.apartment_id);
    }


    return (
        <div className="room__item item-room" onClick={handleClick}>
            <div className="item-room__image">
                <img src={data.img} alt="" />
            </div>
            <div className="item-room__place">
                <p className="item-room__name">{data.name}</p>
                {
                    data.info != 'Не указано' &&
                    <p className="item-room__info">Отделка: {data.info}</p>
                }
                <p className="item-room__floor">
                    {data.floor}, {type}. №{data.number}
                </p>
            </div>
            <div className="item-room__description">
                {data.room !== 0 && <div className="item-room__data">
                    <p className="item-room__number">{data.room === 100 ? 'Студия' : data.room}</p>
                    <p className="item-room__what">комнаты</p>
                </div>
                }
                <div className="item-room__data">
                    <p className="item-room__number">{data.square}</p>
                    <p className="item-room__what">кв.м</p>
                </div>
                {
                    !!data.show_price &&
                    <div className="item-room__data">
                        <p className="item-room__number">{data.price}</p>
                        <p className="item-room__what">рублей</p>
                    </div>
                }
            </div>
            <button className="item-room__more">
                <span>Подробнее</span>
                <svg>
                    <use xlinkHref="/static/svg/sprite.svg#return" />
                </svg>
            </button>
        </div>
    );
}

export default memo(RoomItem);
